import { useState } from "react";
import DataTable from "react-data-table-component";
//
import { useFetchPincodesMutation } from "../../../features/admin/pincode/pincodeApi";

export default function PincodeMaster() {
    const columns = [
        {
            name: "S.No",
            selector: (row, idx) => idx + 1,
            sortable: true,
            width: "80px",
        },
        {
            name: "Pincode",
            selector: (row) => row.pincode,
            sortable: true,
        },
        {
            name: "State",
            selector: (row) => row.state,
            sortable: true,
        },
        {
            name: "City",
            selector: (row) => row.city,
            sortable: true,
        },
        {
            name: "District",
            selector: (row) => row.district,
            sortable: true,
        },
    ];

    const initialRequest = {
        pincode: "",
        country: "",
        state: "",
    };

    const [request, setRequest] = useState(initialRequest);

    const [fetchPincodes, { isLoading: pincodeLoading, data: pincodeData }] =
        useFetchPincodesMutation();

    const handleSubmit = async (event) => {
        if (event.preventDefault) {
            event.preventDefault();
        }

        if (!pincodeLoading) {
            fetchPincodes({
                token: sessionStorage.getItem("access_token"),
                body: request,
            });
        }
    };

    return (
        <div className="page-content">
            <div className="card p-4">
                <div className="d-flex justify-content-between align-items-center flex-wrap grid-margin">
                    <h4 className="mb-3 mb-md-0 card-title">Pincode Master</h4>
                </div>

                <form
                    onSubmit={handleSubmit}
                    className="grid md:grid-cols-4 grid-cols-1 gap-4 items-end"
                    style={{
                        pointerEvents: pincodeLoading ? "none" : "inherit",
                    }}
                >
                    <div className="flex flex-col justify-start items-start w-full">
                        <label>Pincode</label>
                        <input
                            type="text"
                            placeholder="Pincode..."
                            className="input w-full"
                            value={request.pincode}
                            onChange={(e) =>
                                setRequest((prev) => ({
                                    ...prev,
                                    pincode: e.target.value?.replace(/\D/g, ""),
                                }))
                            }
                        />
                    </div>

                    <div className="flex flex-col justify-start items-start w-full">
                        <label>Country</label>
                        <input
                            type="text"
                            placeholder="Country..."
                            className="input w-full"
                            value={request.country}
                            onChange={(e) =>
                                setRequest((prev) => ({
                                    ...prev,
                                    country: e.target.value?.trim(),
                                }))
                            }
                        />
                    </div>

                    <div className="flex flex-col justify-start items-start w-full">
                        <label>State</label>
                        <input
                            type="text"
                            placeholder="State..."
                            className="input w-full"
                            value={request.state}
                            onChange={(e) =>
                                setRequest((prev) => ({
                                    ...prev,
                                    state: e.target.value?.trim(),
                                }))
                            }
                        />
                    </div>

                    <div className="flex flex-row gap-2 justify-start items-stretch w-full">
                        <button
                            type="submit"
                            className="btn btn-primary w-full"
                        >
                            Search
                        </button>

                        <button
                            type="button"
                            className="btn btn-outline-primary w-full"
                            onClick={() => setRequest(initialRequest)}
                        >
                            Clear Filters
                        </button>
                    </div>
                </form>

                <div className="table-responsive">
                    <DataTable
                        // title="All Workflows"
                        data={pincodeData?.body}
                        columns={columns}
                        // onSelectedRowsChange={handleChange}
                        // customStyles={customStyles}
                        highlightOnHover
                        pointerOnHover
                        pagination
                        // paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                        subHeader
                        // subHeaderComponent={subHeaderComponentMemo}
                        // selectableRows
                        persistTableHead
                    />
                </div>
            </div>
        </div>
    );
}
